const getSentenceGender = (sentence: string): string | undefined => {
  const word = sentence.split(' ')[0];
  const isPlural = word[word.length - 1] === 's';

  const maleCases = [
    'o',
    'or',
    'eiro',
    'ista',
    'dor',
    'ente',
    'ante',
    'ente',
    'nte',
    'ão',
    'ês',
    'ista',
    'ador',
    'ador',
    'idor',
    'ar',
    'er',
    'ir',
    'e',
    'il',
    'd',
  ];

  for (const sufixo of maleCases) {
    if (word.endsWith(sufixo)) return isPlural ? 'os' : 'o';
  }

  return isPlural ? 'as' : 'a';
};

export default getSentenceGender;
